import { useCallback, useContext, useMemo } from "react";
import { ProfileService } from "../services/profiles.service";
import { AuthContext } from "@modules/auth/contexts/auth-plus.context";

export const useProfiles = () => {
  const { auth, setAuth, logout } = useContext(AuthContext);
  const profileService = useMemo(() => new ProfileService(), []);

  const loadProfile = useCallback(
    async (userId: string) => {
      return await profileService.getProfile(auth, setAuth, logout, userId);
    },
    [auth, setAuth, logout, profileService],
  );

  const getBalance = useCallback(
    async (userId: string) => {
      return await profileService.getBalanceWallet(auth, setAuth, logout, userId);
    },
    [auth, setAuth, logout, profileService],
  );

  const getWeeklySchedule = useCallback(
    async (userId: string) => {
      return await profileService.getWeeklySchedule(
        auth,
        setAuth,
        logout,
        userId,
      );
    },
    [auth, setAuth, logout, profileService],
  );

  const loadUserPublicPosts = useCallback(
    async (userId: string) => {
      return await profileService.getAllUserPublicPosts(
        auth,
        setAuth,
        logout,
        userId,
      );
    },
    [auth, setAuth, logout, profileService],
  );

  return { loadProfile, getBalance, getWeeklySchedule, loadUserPublicPosts };
};
